<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" [defaultHref]="rootUrl"></ion-back-button>
    </ion-buttons>

    <smr-stylist-picker
      *ngIf="stylist"
      [hidden]="errorOccurredWhileLoadingStylists"
      [stylistID]="stylistCol ? stylistCol : stylist.getID()"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      cssClass="smr-stylist-picker-for-clients"
      (stylistSelect)="onStylistSelect($event)"
    >
    </smr-stylist-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoadingStylists"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylists"
    (click)="onRetry()"
  ></salonmonster-tap-retry>


    <ion-item>
      <h4><b>Select a client for this booking</b></h4>
    </ion-item>
    <ion-grid class="sm-booking-form-client-list-container" style="height: 100%">
      <ion-row style="height: 100%">
        <ion-col size="12" class="smr-client-list" style="height: 100%;">
          <smr-client-picker
          style="height: 100%; min-height:1000px"
            *ngIf="stylist"
            [stylist]="stylist"
            (clientSelect)="onClientSelect($event)"
          >
          </smr-client-picker>
        </ion-col>
      </ion-row>
    </ion-grid>
</ion-content>

<ion-footer class="ion-justify-content-evenly">
  <ion-row>
    <ion-col>
      <ion-button expand="block" fill="outline"  (click)="onCreateTimeOff()">
        Block time off
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button expand="block" fill="solid" (click)="onClientAdd()">
        New client
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
